import React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import theme, { textStyles as ts } from '../../theme';

const Anchor = styled.a`
  ${ts.body};
  && {
    color: ${theme('colors.accentQuarternary')};
  }
  text-decoration: none;
  &:hover {
    color: ${theme('colors.accentQuarternary').apply(col => lighten(0.2, col))};
  }
  &:active {
    color: ${theme('colors.accentQuarternary')};
  }
  &:visited {
    color: ${theme('colors.accentQuarternary')};
  }
`;

export default ({ ...props }) => <Anchor {...props} />;
